/**
 * Unicode bidi isolates, to keep a piece of text in its own direction inside a
 * sentence. Mathematics follows `MATH_DIRECTION` (src/config/math.ts): in Arabic
 * an expression is isolated right-to-left, so «3 + 4 = 7» reads from the right.
 */
const LRI = '⁦';
const RLI = '⁧';
const FSI = '⁨';
const PDI = '⁩';

export const isolateLtr = (text: string | number) => `${LRI}${text}${PDI}`;
export const isolateRtl = (text: string | number) => `${RLI}${text}${PDI}`;
export const isolateAuto = (text: string | number) => `${FSI}${text}${PDI}`;

/** Removes isolate controls, e.g. before comparing or speaking text. */
export const stripBidiControls = (text: string) => text.replace(/[⁦-⁩‎‏]/g, '');
